import { core_backend_url } from "../../config"

export const bankApi = {
    getCertificates: `${core_backend_url}certificate/certificates`,
    uploadCertificateBank: `${core_backend_url}certificate/upload/bank`,
    sendDisapprovalMail: `${core_backend_url}certificate/send-disapproval-notification-link-to-transferee`,
    verifyLink: `${core_backend_url}certificate/link-verification`,
    requestAnotherLink: `${core_backend_url}certificate/request-a-new-link`,
    bankChangeStatus: `${core_backend_url}certificate/disbursement/approval/bank`,
    getComments: (certificate_id) =>`${core_backend_url}certificate/${certificate_id}/comments`,
    getLetterForExternalUser: (reference) => `${core_backend_url}digital-letters/${reference}/external`,
    replyLetterAsExternalUser: `${core_backend_url}digital-letters/reply`,
    addComment: `${core_backend_url}certificate/add-comment`,
    getInboxLetters: `${core_backend_url}digital-letters/inbox`,
    getSentLetters: `${core_backend_url}digital-letters/sent`,
    getDraftLetters: `${core_backend_url}digital-letters/draft`,
    sendLetter: `${core_backend_url}digital-letters/send`,
    getUsers: `${core_backend_url}digital-letters/users`,
    readLetter: (id) => `${core_backend_url}digital-letters/inbox/opened/${id}`,
    deleteLetter: (id) => `${core_backend_url}digital-letters/inbox/delete/${id}`,
    changeStatus: `${core_backend_url}certificate/change-status`,
}